<template>
  <section class="hero-section">
    <img
      v-if="articleImage"
      :src="articleImage"
      alt="hero"
    />
    <NuxtPicture
      v-else
      src="/images/journal/article/main.png"
      alt="hero"
    />
    <ShareButton />
  </section>
</template>

<script>
import ShareButton from '~/components/Common/ShareButton/ShareButton.vue';
import cloudinaryImage from '~/utils/helpers/cloudinaryImage';

export default {
  components: { ShareButton },
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  computed: {
    articleImage() {
      return this.article.image
        ? cloudinaryImage({ imagePath: this.article.image, width: 1728 })
        : null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './HeroSection.scss';
</style>
